import { useEffect } from "react";

const SCHEMA_ID = "site-organization-schema";
const CANONICAL_HOST = "https://ccchaps.com";

/**
 * Site-wide Organization JSON-LD. Uses ONLY information that is already
 * publicly visible on the CCCHAPS website (name, alternate name, canonical
 * URL, logo, official email, and the accurate onsite service area).
 *
 * We use the base "Organization" type — not LocalBusiness — because
 * LocalBusiness expects fields (street address, opening hours, telephone
 * displayed with the business, etc.) that are not intentionally public on
 * the site. Organization is Google's recommended fallback for that case.
 */
export default function SiteOrganizationSchema() {
  useEffect(() => {
    const data = {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "California Corporate Chaplains",
      alternateName: "CCCHAPS",
      url: CANONICAL_HOST,
      logo: `${CANONICAL_HOST}/ccchaps-logo.png`,
      email: "office@ccchaps.com",
      description:
        "California Corporate Chaplains (CCCHAPS) provides relational, non-clinical workplace chaplaincy. Scheduled onsite chaplaincy is currently available in Sacramento, Placer, El Dorado, and Nevada Counties. Remote chaplain support is available across California and nationwide, based on service arrangement and availability.",
      areaServed: [
        { "@type": "AdministrativeArea", name: "Sacramento County, California" },
        { "@type": "AdministrativeArea", name: "Placer County, California" },
        { "@type": "AdministrativeArea", name: "El Dorado County, California" },
        { "@type": "AdministrativeArea", name: "Nevada County, California" },
        { "@type": "AdministrativeArea", name: "California (remote chaplain support)" },
        { "@type": "Country", name: "United States (remote chaplain support)" },
      ],
      knowsAbout: [
        "Workplace chaplaincy",
        "Corporate chaplain services",
        "Employee chaplain support",
        "Non-clinical emotional support",
        "Crisis, grief and bereavement support",
        "Healthcare and hospice chaplaincy",
        "Senior living chaplaincy",
      ],
      contactPoint: [
        {
          "@type": "ContactPoint",
          contactType: "customer support",
          email: "office@ccchaps.com",
          availableLanguage: ["English"],
        },
      ],
    };

    let el = document.getElementById(SCHEMA_ID);
    if (!el) {
      el = document.createElement("script");
      el.id = SCHEMA_ID;
      el.type = "application/ld+json";
      document.head.appendChild(el);
    }
    el.text = JSON.stringify(data);

    return () => {
      const node = document.getElementById(SCHEMA_ID);
      if (node) node.remove();
    };
  }, []);

  return null;
}
